import z, { boolean, object, string } from 'zod';

export const schema = object({
  otpCode: string().regex(/^\d{6}$/, 'errors.input.required'),
  trustUserAgent: boolean(),
});

export type OTPFormSchema = z.infer<typeof schema>;
